<template>
  <div id="modal" class="modal" role="dialog" v-show="alert">
    <button
      type="button"
      class="btn-close"
      @click="close"
      aria-label="Close modal"
			title="Close"
    >
      ×
    </button>

    <template v-if="alert">
	    <header class="modal-header">
	      <h3 class="modal-header-title">Edit saved search / Job Alert</h3>
	    </header>

	    <section class="modal-body">
	      <form class="form-EditSavedSearchAlert" action="">

	        <div class="form-group">
	          <label class="form-label" for="job_title">Label</label>
	          <input class="form-input" type="text" id="job_title" name="job_title" v-model="alert.title" placeholder="Title">
	        </div>

					<!-- Removed 22-01-24 - Don't think this is needed any more - Trello card 510 -->
	        <!-- <div class="form-group">
	          <div class="form-checkbox-container">
	            <input class="form-checkbox" type="checkbox" id="job_alert" name="job_alert" v-model="alert.active">
	            <label for="job_alert">Job alert - {{ checkboxStatus }}</label>
	          </div>
	        </div> -->

	        <div class="form-group">
	          <label class="form-label" for="email">Email</label>
	          <input class="form-input" type="text" id="email" name="email" v-model="alert.email" placeholder="Email">
	        </div>

	        <div class="form-group">
	          <label class="form-label" for="job_alert_frequency">Frequency the alerts are sent</label>
	          <select class="form-select" name="job_alert_frequency" id="job_alert_frequency" v-model="alert.frequency">
              <option v-for="freq in frequency" :key="freq" :value="freq">{{ freq }}</option>
	          </select>
	        </div>

	      </form>
	    </section>

	    <footer class="modal-footer">
	      <div class="btn-group between">
	        <button class="btn btn-applied" @click="doDelete">Delete alert</button>
	        <button class="btn btn-blue-dark" @click="doSave">Update</button>
	      </div>
	    </footer>

			<block-spinner :active="spinner" color="text-blue-dark"></block-spinner>
	  </template>
  </div>
</template>s

<script>
	import AuthMixins from '@/mixins/AuthMixins';

  export default {
    name: 'EditSavedSearchAlert',

		mixins: [AuthMixins],

    props: {
    	payload: {
    		type: Object
    	}
    },

    data() {
      return {
        alert: false,
        frequency: ['Daily','Weekly','Monthly'],
				spinner: false
      }
    },

    mounted() {
    	this.loadJobAlert();
    },

    methods: {
    	loadJobAlert() {
    		let payload = {'job_alert_id':this.payload.job_alert_id}
	  		return this.$api.loadJobAlert(payload).then(
	        (response) => {
	        	if (response.data.status == 'success') {
	        		this.alert = response.data.response;
	        	}
	        }
	      ).catch((response) => {
	        console.log("Could not load alert.", response);
	      });
    	},
      close() {
        this.$emit('close');
      },
      doDelete() {
        if(!this.spinner) {
          this.spinner = true;
          let payload = {'job_alert_id':this.payload.job_alert_id};
          return this.$api.deleteJobAlert(payload).then(
            (response) => {
              if (response.data.status == 'success') {
                this.$nextTick(() => {
                  this.updateUser(response.data.enc_user);
                  this.close();
                  this.spinner = false;
                  this.emitter.emit("clear:search");
                  this.emitter.emit('toast', {message:'Deleted alert successfully', type:'success'});
                });
              }
            }
          ).catch((response) => {
            console.log("Could not saved alert.", response);
          });
        }
      },
      doSave() {
        if(!this.spinner) {
          this.spinner = true;
          let payload = {...this.alert, 'job_alert_id':this.payload.job_alert_id};
          return this.$api.updateJobAlert(payload).then(
            (response) => {
              if (response.data.status == 'success') {
                this.$nextTick(() => {
                  this.updateUser(response.data.enc_user);
                  this.close();
                  this.spinner = false;
                  this.closeCard(payload['job_alert_id']);
                  this.emitter.emit('toast', {message:'Updated alert successfully', type:'success'});
                });
              }
            }
          ).catch((response) => {
            console.log("Could not saved alert.", response);
          });
        }
      },
			closeCard(job_alert_id) {
				this.emitter.emit('close:saved-search-alerts', job_alert_id);
			},
    },

    computed: {
      checkboxStatus() {
        return this.alert.active ? 'Active' : 'Inactive';
      }
    }
  };
</script>
